const RegExs = {
  mobileReg:
    /(\+98|0|98|0098)?([ ]|-|[()]){0,2}9[0-9]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}/gi,
  junkReg: /[^\d]/gi,
  persinNum: [/۰/gi, /۱/gi, /۲/gi, /۳/gi, /۴/gi, /۵/gi, /۶/gi, /۷/gi, /۸/gi, /۹/gi],
  webpack_script_regex: /\.(js|jsx)$/,
  webpack_script_exclude_regex: /node_modules/,
  webpack_style_regex: /\.(sa|sc|c)ss$/,
  webpack_html_regex: /\.html$/,
  webpack_media_regex: /\.(jpg|jpeg|png|gif|svg)$/,
  webpack_fonts_regex: /\.(woff(2)?|ttf|eot)(\?v=\d+\.\d+\.\d+)?$/,
  webpack_webmanifest_regex: /manifest.json$/,
  SP_VMS_env_regex: /^SP_/i,
  phoneNumber_pattern: /^(\+98|09)\d{9}$/g,
  shabaNumber: /^(?:IR)(?=.{24}$)[0-9]*$/,
  number_pattern: /^\d+$/,
  email_pattern:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
};

export const {
  mobileReg,
  junkReg,
  persinNum,
  webpack_script_regex,
  webpack_script_exclude_regex,
  webpack_style_regex,
  webpack_html_regex,
  webpack_media_regex,
  webpack_fonts_regex,
  webpack_webmanifest_regex,
  SP_VMS_env_regex,
  phoneNumber_pattern,
  shabaNumber,
  number_pattern,
  email_pattern
} = RegExs;

export default RegExs;
